module.exports = __webpack_public_path__ + "img/emoticon-csat-3-off.c311a7ab.svg";